import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { ReportType } from "../../api/api-clientInformation";

export enum ReportFormPage {
    GENERAL = 'general',
    EQUIPMENTS = 'equipments',
    FINDING_DESCRIPTION = 'finding-description',
    RISK_EVALUATION = 'risk-evaluation',
    RIPT = 'RIPT',
    MITIGATION_AND_RESOLUTION_PLAN = 'mitigation-and-resolution-plan',
    APPROVAL_FLOW = 'approval-flow',
    NOTES_ATTACHMENTS = 'notes-attachments',
    ACTION_ITEM = 'action-items',
    AUDIT_HISTORY = 'audit-history',
}

export const REPORT_PAGE_LIST = [
    ReportFormPage.GENERAL,
    ReportFormPage.EQUIPMENTS,
    ReportFormPage.FINDING_DESCRIPTION,
    ReportFormPage.RISK_EVALUATION,
    ReportFormPage.RIPT,
    ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN,
    ReportFormPage.APPROVAL_FLOW,
    ReportFormPage.NOTES_ATTACHMENTS,
    ReportFormPage.AUDIT_HISTORY
]

export const REPORT_PAGE_LIST_WITH_CONDITIONS = [
    {
        page: ReportFormPage.GENERAL,
        show: []
    },
    {
        page: ReportFormPage.EQUIPMENTS,
        show: []
    },
    {
        page: ReportFormPage.FINDING_DESCRIPTION,
        show: [
            ReportType.IntegrityDeficiency,
            ReportType.ReliabilityDeficiency,
            ReportType.IntegrityThreat,
        ]
    },
    {
        page: ReportFormPage.RISK_EVALUATION,
        show: [
            ReportType.IntegrityDeficiency,
            ReportType.ReliabilityDeficiency,
            ReportType.TaskDeferral
        ]
    },
    {
        page: ReportFormPage.RIPT,
        show: [
            ReportType.IntegrityDeficiency,
            ReportType.ReliabilityDeficiency,
            ReportType.IntegrityThreat,
            ReportType.ReliabilityThreat,
            ReportType.AnomalyReport
        ]
    },
    {
        page: ReportFormPage.MITIGATION_AND_RESOLUTION_PLAN,
        show: []
    },
    {
        page: ReportFormPage.APPROVAL_FLOW,
        show: []
    },
    {
        page: ReportFormPage.NOTES_ATTACHMENTS,
        show: []
    },
    {
        page: ReportFormPage.AUDIT_HISTORY,
        show: []
    },
]

@Injectable()
export class ReportFormControlService {
    private _save = new Subject<ReportFormPage>();

    public get save$() {
        return this._save.asObservable();
    }

    save(step: ReportFormPage): void {
        this._save.next(step);
    }
}
